module.exports = __webpack_public_path__ + "static/media/launch.dd8e86d2.png";